import { GlobalAssetTableEvents } from "../analytics/events/global_asset_table";
import { track } from "../analytics/track";

// // // //

/**
 * trackGlobalAssetTableChangeDistribution
 * Tracks the event when a user changes the distribution filter in the Global Asset Table
 */
export function trackGlobalAssetTableChangeDistribution(props: {
    distributionType: string;
}) {
    track(GlobalAssetTableEvents.ChangeDistribution, props);
}
